/* eslint-disable react/button-has-type */
/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable @typescript-eslint/no-var-requires */
import React from 'react';
import ImgPoint from '../../../../../assets/animation_point.gif';
import './animation001.less';

interface IAnimation001Item {
  icon?: string;
  img: string;
  title?: string;
  text: React.ReactNode | string;
  bg: string;
}

interface IAnimation001Props {
  title: React.ReactNode | string;
  items: IAnimation001Item[];
  onCompleted?: () => void;
  className?: string;
}

const getImg = (img: string) => require(`../../../../../assets/${img}`).default;

const Animation001: React.FunctionComponent<IAnimation001Props> = ({
  title,
  items,
  onCompleted,
  className,
}) => {
  const [play, setPlay] = React.useState(1);
  const [isPlayed, setIsPlayed] = React.useState(false);
  const startPlay = (next = 1) => {
    if (isPlayed) {
      return;
    }
    next += 1;
    setPlay(next);
    setIsPlayed(true);
    if (next <= 4) {
      setTimeout(() => startPlay(next), 1000);
    } else {
      onCompleted && onCompleted();
    }
  };
  return (
    <div className={`animation001 component ${className}`}>
      {title && typeof title === 'string' ? (
        <div
          className="animation001-1"
          dangerouslySetInnerHTML={{ __html: title }}
        />
      ) : (
        <div className="animation001-1">{title}</div>
      )}
      <div className="animation001-2">
        {items.map((itm: IAnimation001Item, idx: number) => (
          <div
            key={idx}
            className={`animation001-item item${idx} animation ${
              play >= idx + 1 ? 'fade-in' : ''
            }`}
            onClick={() => startPlay()}
          >
            <img
              className={`click-point ${play > 1 ? 'hide' : ''}`}
              src={ImgPoint}
              alt=""
            />
            {itm.icon && (
              <div className="animation001-icon">
                <img src={getImg(itm.icon)} alt="" />
              </div>
            )}
            {itm.title && (
              <div className="animation001-title-container">
                <div className="animation001-title">{itm.title}</div>{' '}
              </div>
            )}
            <div className="animation001-body">
              <img src={getImg(itm.img)} alt="" />
              {typeof itm.text === 'string' ? (
                <div
                  className="text"
                  style={{ backgroundColor: itm.bg }}
                  dangerouslySetInnerHTML={{ __html: itm.text }}
                />
              ) : (
                <div className="text" style={{ backgroundColor: itm.bg }}>
                  {itm.text}
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Animation001;
